export enum ButtonMode {
  OnLight = 'onLight',
  OnDark = 'onDark',
}
